exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndl[data-v-9ecae406] {\n  margin-bottom: 0;\n}\ndl dt[data-v-9ecae406], dl dd[data-v-9ecae406] {\n    margin-bottom: 0;\n}\ndl dt.comment[data-v-9ecae406], dl dd.comment[data-v-9ecae406] {\n      color: #ff0000;\n}\ndl dd[data-v-9ecae406] {\n    white-space: pre-wrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ecae406","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/parts/Information.vue
// module id = FcCe
// module chunks = 1